// src/components/ChatArea.js
import React, { useEffect, useRef, useState } from "react";
import "./support.scss"; // Import CSS for ChatArea styling
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Send } from "@mui/icons-material";
import { db, functions } from "../../firebase";
import {
  FieldValue,
  arrayUnion,
  doc,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";

const ChatArea = ({ selectedRequest }) => {
  const [status, setStatus] = useState(selectedRequest?.status ?? "closed");
  const [messages, setMessages] = useState(selectedRequest?.messages ?? []);

  const [textFieldMessage, setTextfieldMessage] = useState("");

  const messagesEndRef = useRef(null);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleButtonClickCloseTicket = async () => {
    setOpen(false);
    const docRef = doc(db, "supportChats", selectedRequest.id);

    await updateDoc(docRef, {
      status: status == "open" ? "closed" : "open",
    });
   
  };

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
  const handleInputMessage = (event) => {
    const { value } = event.target;
    setTextfieldMessage(value);
  };
  const handleSendMessage = async () => {
    if (textFieldMessage.trim().length != 0) {
      const docRef = doc(db, "supportChats", selectedRequest.id);
      const messageMap = {
        from: "admin",
        message: textFieldMessage.trim(),
        timestamp: new Date(),
      };
      await updateDoc(docRef, {
        messages: arrayUnion(messageMap),
      });
      //call push function
      const sendPushToUser = httpsCallable(functions,"supportChatPushNotification")
      sendPushToUser({
        userUID:`${selectedRequest.userID}`,
        replyMessage:textFieldMessage.trim(),
        ticketID:`${selectedRequest.ticketID}`,
        ticketUID:`${selectedRequest.id}`
      })

      setTextfieldMessage("");
    } else {
      alert("Please enter a message to send.");
    }
  };

  const updateData = async (count) => {
    const docRef = doc(db, "supportChats", selectedRequest.id);

    await updateDoc(docRef, {
      countUserMessages: count,
      setAdminStatus: false,
    });
  };
  useEffect(() => {
    if (selectedRequest) {
      const unsubscribe = onSnapshot(
        doc(db, "supportChats", selectedRequest.id),
        (doc) => {
          if (doc.exists) {
            const serverCountUserMessage = doc.data().countUserMessages;
            let countUserMessages = 0;
            doc.data().messages.map((messageMap) => {
              const from = messageMap.from;
              if (from.toLowerCase() === "user") {
                countUserMessages++;
              }
            });
            if (
              countUserMessages != 0 &&
              serverCountUserMessage != countUserMessages
            ) {
              updateData(countUserMessages);
            }

            setMessages(doc.data().messages);
            setStatus(doc.data().status);
          }
        }
      );

      return () => unsubscribe();
    }
  }, [selectedRequest]);
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };
  return (
    <div className="chat-area">
      {selectedRequest && (
        <>
          <div className="chat-header">
            <Box>
            <h5>Ticket ID: {selectedRequest.ticketID}</h5>
            <Typography fontSize={"12px"}>Created at {selectedRequest.timestamp.toDate().toLocaleString()}</Typography>
            </Box>
            <Stack direction={"row"}>
            <Button
              variant="text"
              href={"/users/" + selectedRequest.userID}
              target="_blank"
              sx={{ marginRight: "10px" }}
            >
               View User Details
            </Button>
              
              <Button variant="contained" onClick={handleClickOpen}>
                {status == "open" ? "Close Ticket" : "Reopen Ticket"}
              </Button>
            </Stack>
          </div>

          <div className="messages">
            {messages.map((message) => (
              <div>
                {message.from == "user" && (
                  <div className="userMessage">
                    <div>
                      <p>{message.message}</p>
                      <span>{message.timestamp.toDate().toLocaleString()}</span>
                    </div>
                  </div>
                )}
                {message.from == "admin" && (
                  <div className="adminMessage">
                    <div>
                      <p>{message.message}</p>
                      <span>{message.timestamp.toDate().toLocaleString()}</span>
                    </div>
                  </div>
                )}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          {status == "open" && (
            <div className="chat-input">
              <TextField
                fullWidth
                label="Type message here"
                variant="standard"
                value={textFieldMessage}
                onChange={handleInputMessage}
                onKeyPress={handleKeyPress}
              />
              <IconButton
                sx={{ marginLeft: "10px" }}
                aria-label="delete"
                size="large"
                color="primary"
                onClick={handleSendMessage}
              >
                <Send />
              </IconButton>
            </div>
          )}
          {status != "open" && (
            <div className="chat-input">
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography>Conversation closed.</Typography>
              </Box>
            </div>
          )}
        </>
      )}
      {!selectedRequest && (
        <div className="center">
          <Typography>
            Select a ticket to assist a customer and provide them with the best
            possible support experience.
          </Typography>
        </div>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to
          {status == "open" ? " close" : " reopen" + " this ticket?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {status == "open"
              ? "Once closed, this ticket can be reopened. Are you sure you want to proceed?"
              : ""}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleButtonClickCloseTicket} autoFocus>
            {status == "open" ? " Close Ticket" : " Reopen Ticket"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ChatArea;
